import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Counter } from '../ui/Counter';
import { Reveal } from '../ui/Reveal';
import { SectionLabel } from '../ui/SectionLabel';
import { SplitText } from '../ui/SplitText';
import { featuredStat, stats } from '../../data/stats';
import { images } from '../../data/images';
export function ImpactSection() {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);
  return <section ref={ref} className="relative isolate overflow-hidden bg-ink py-28 text-white lg:py-40" data-id="element-162" data-mp="3nzxknbsrk2t1">
      <motion.img src={images.port} alt="" style={{
      y
    }} className="absolute inset-x-0 -top-[15%] -z-20 h-[130%] w-full object-cover" data-id="element-163" data-mp="3s20zmaen5pj2" />
      <div className="absolute inset-0 -z-10 bg-ink/80" data-id="element-164" data-mp="5ub32pvx1ulz" />

      <div className="mx-auto grid max-w-[1440px] gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:items-end" data-id="element-165" data-mp="5uub9evrl4mt">
        <div className="lg:col-span-7" data-id="element-166" data-mp="flpf02s6j89w">
          <Reveal data-id="element-167" data-mp="alkywdv6ofk7">
            <SectionLabel tone="dark" data-id="element-168" data-mp="al1lnaghafci">Impact</SectionLabel>
          </Reveal>
          <h2 className="mt-6 max-w-2xl text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-169" data-mp="6jg2j7dcp4tv">
            <SplitText text="Des gains concrets, mesurés et durables." data-id="element-170" data-mp="1lej2lc0j3hv" />
          </h2>
          <Reveal delay={0.15} data-id="element-171" data-mp="ybf6oh0nbdxl">
            <p className="mt-10 text-[clamp(5rem,13vw,11rem)] font-medium leading-[0.9] tracking-[-0.05em] text-brass" data-id="element-172" data-mp="yadvmcjmqrfv">
              <Counter value={featuredStat.value} prefix={featuredStat.prefix} suffix={featuredStat.suffix} data-id="element-173" data-mp="ubetezpa98s4" />
            </p>
            <p className="mt-4 max-w-md text-lg leading-relaxed text-white/75" data-id="element-174" data-mp="kjilyy1b46b8">{featuredStat.label}</p>
          </Reveal>
        </div>

        <dl className="lg:col-span-5" data-id="element-175" data-mp="1hzy0xd0idhj5">
          {stats.map((s, i) => <Reveal key={s.label} delay={0.08 * i} data-id="element-176" data-mp="1d7mqhg856dcc" data-mpi={i}>
              <div className="grid grid-cols-[minmax(0,140px)_1fr] items-baseline gap-6 border-t border-white/15 py-6" data-id="element-177" data-mp="1d6v7r5zn8a3h">
                <dt className="sr-only" data-id="element-178" data-mp="1w6rc00v3ze5h">{s.label}</dt>
                <dd className="text-4xl font-medium tracking-tight" data-id="element-179" data-mp="2126lkgm32nw3">
                  <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} data-id="element-180" data-mp="1ncmnho3g6et4" />
                </dd>
                <dd className="leading-relaxed text-white/70" data-id="element-181" data-mp="1rd6j2n8dhad5">{s.label}</dd>
              </div>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}